import * as React from "react";
const SvgCafeManager = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 54, height: 51, viewBox: "0 0 54 51", fill: "none", ...props }, "...");
export default SvgCafeManager;
